NtechApp.StickyNav = function() {
    var me = this;

    this._$target = null;
    this._hasTarget = false;

    this._$sticky = null;

    this._construct = function () {
        me._$target = $("body").find("[data-stickyNavTarget]");
        if(me._$target.length == 0)
            return;

        me._createSticky();
        me._updateSticky();

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(window).on("resize.NtechApp.StickyNav", function() {
            me._updateSticky();
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.StickyNav, {
    _createSticky: function() {
        this._$sticky = $("<div/>").addClass("stickyNavFiller");
        $("body").append(this._$sticky);
    },

    _updateSticky: function() {
        var mode = this._getMode();
        if(mode == "hidden") {
            this._$sticky.css("display", "none");
            return;
        }

        this._$sticky.css("display", "block");
        this._$sticky.css({
            width: "100%",
            height: (this._$target.outerHeight()) + "px"
        });
    },

    _getMode: function() { 
        var cs = window.getComputedStyle(this._$target.get(0), ':after');

        var content = cs.getPropertyValue("content").replace(/"/g, "");
        content = content.replace(/'/g, ""); // Android fix

        return content;
    }
});